import { render, staticRenderFns } from "./BombaPoco.vue?vue&type=template&id=735af41a&"
import script from "./BombaPoco.vue?vue&type=script&lang=js&"
export * from "./BombaPoco.vue?vue&type=script&lang=js&"
import style0 from "./BombaPoco.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports